export const getUsageFilter = state => state.usageReport.filter
